import React from 'react';
import {Platform, Song} from '../../../../../../types';

import {Remove} from './icons';
import SubtleButton from '../../../../../SubtleButton';
import styles from './QueueItem.module.scss';
import {useObsidianContext} from '../../../../../../context/ObsidianProvider';

interface Props {
  song: Song;
  onRemove(id: Song['id']): void;
}

export default function QueueItem({song, onRemove}: Props) {
  const {obsidian} = useObsidianContext();
  const {name, artistName} = song;
  return (
    <div className={styles.QueueItem}>
      {/* TODO: This currently doesn't update displayed song info. Once obsidian*/}
      <SubtleButton onClick={() => obsidian.play(song, Platform.AppleMusic)}>
        <div className={styles.SongWrapper}>
          <div className={styles.Title}>{name}</div>
          <span className={styles.Artist}>{artistName}</span>
        </div>
        {/** TODO: position this absolutely as sibling of Subtlebutton, show on QueueItem hover */}
        <button
          className={styles.RemoveButton}
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onRemove(song.id);
          }}
        >
          {Remove}
        </button>
      </SubtleButton>
    </div>
  );
}
